@if (currentPage == 'orgLocationUK') {
  <div class="col-xs-12 grbno logindocUK">
  {{paracontent}}</div>
} @else {
  <div class="col-xs-12 grbno logindocUK" [ngClass]="currentPage == 'account'?'dashboard_docno':''">{{paracontent}}</div>
}
